import { PageIcon } from "entities/pages/types";
import { FC } from "react";
import { BadgeDiscountIcon } from "shared/theme/icons/BadgeDiscountIcon";
import { CardPlayIcon } from "shared/theme/icons/CardPlayIcon";
import { CardsIcon } from "shared/theme/icons/CardsIcon";
import { CheckmarkBadgeIcon } from "shared/theme/icons/CheckmarkBadgeIcon";
import { ChipIcon } from "shared/theme/icons/ChipIcon";
import { DiceIcon } from "shared/theme/icons/DiceIcon";
import { FireIcon } from "shared/theme/icons/FireIcon";
import { GiftIcon } from "shared/theme/icons/GiftIcon";
import { HeartIcon } from "shared/theme/icons/HeartIcon";
import { HouseIcon } from "shared/theme/icons/HouseIcon";
import { InfoIcon } from "shared/theme/icons/InfoIcon";
import { PlayIcon } from "shared/theme/icons/PlayIcon";
import { PuzzleIcon } from "shared/theme/icons/PuzzleIcon";
import { QuestionMarkIcon } from "shared/theme/icons/QuestionMarkIcon";
import { RecentlyIcon } from "shared/theme/icons/RecentlyIcon";
import { RouletteIcon } from "shared/theme/icons/RouletteIcon";
import { SportsBallIcon } from "shared/theme/icons/SportsBallIcon";
import { StarBigIcon } from "shared/theme/icons/StarBigIcon";
import { TicketDiscountIcon } from "shared/theme/icons/TicketDiscountIcon";
import { TicketIcon } from "shared/theme/icons/TicketIcon";
import { TimeIcon } from "shared/theme/icons/TimeIcon";
import { TrophyIcon } from "shared/theme/icons/TrophyIcon";
import { IconType } from "shared/theme/icons/types";

export const pageIcons: { name: PageIcon; Component: FC<IconType> }[] = [
  { name: PageIcon.CheckmarkBadge, Component: CheckmarkBadgeIcon },
  { name: PageIcon.Chip, Component: ChipIcon },
  { name: PageIcon.QuestionMark, Component: QuestionMarkIcon },
  { name: PageIcon.Cards, Component: CardsIcon },
  { name: PageIcon.Dice, Component: DiceIcon },
  { name: PageIcon.Play, Component: PlayIcon },
  { name: PageIcon.Roulette, Component: RouletteIcon },
  { name: PageIcon.Heart, Component: HeartIcon },
  { name: PageIcon.Star, Component: StarBigIcon },
  { name: PageIcon.Fire, Component: FireIcon },
  { name: PageIcon.Recently, Component: RecentlyIcon },
  { name: PageIcon.Gift, Component: GiftIcon },
  { name: PageIcon.Ticket, Component: TicketIcon },
  { name: PageIcon.TicketDiscount, Component: TicketDiscountIcon },
  { name: PageIcon.Puzzle, Component: PuzzleIcon },
  { name: PageIcon.Time, Component: TimeIcon },
  { name: PageIcon.Info, Component: InfoIcon },
  { name: PageIcon.BadgeDiscount, Component: BadgeDiscountIcon },
  { name: PageIcon.Trophy, Component: TrophyIcon },
  { name: PageIcon.House, Component: HouseIcon },
  { name: PageIcon.CardPlay, Component: CardPlayIcon },
  { name: PageIcon.SportsBall, Component: SportsBallIcon },
];
